
namespace RioERP.Users {
    export class TeachersColumns {
        static columnsKey = 'Users.Teachers';
    }
}